export default "__VITE_ASSET__5bd0d9df__"